import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function Files() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
        Files
      </Typography>
      <Paper sx={{ p: 4, mt: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          Files management page - Coming soon...
        </Typography>
      </Paper>
    </Box>
  );
}
